import { render } from "./SchoolMain.vue?vue&type=template&id=54589937&scoped=true&ts=true"
import script from "./SchoolMain.vue?vue&type=script&lang=ts"
export * from "./SchoolMain.vue?vue&type=script&lang=ts"

import "./SchoolMain.vue?vue&type=style&index=0&id=54589937&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54589937"]])

export default __exports__